export const GET_ROLES = "GET_ROLES";
export const GET_LIST_ROLES = "GET_LIST_ROLES";
export const GET_ROLE = "GET_ROLE";
export const SET_ROLES = "SET_ROLES";
export const SET_LIST_ROLES = "SET_LIST_ROLES";
export const SET_ONE_ROLE = "SET_ONE_ROLE";
export const ADD_ROLE = "ADD_ROLE";
export const SET_NEW_ROLE = "SET_NEW_ROLE";
export const EDIT_ROLE = "EDIT_ROLE";
export const SET_EDIT_ROLE = "SET_EDIT_ROLE";
export const SET_DELETE_ROLE = "SET_DELETE_ROLE";
export const SET_DELETE_MULTI_ROLE = "SET_DELETE_MULTI_ROLE";
export const DELETE_ROLE = "DELETE_ROLE";
export const DELETE_MULTI_ROLE = "DELETE_MULTI_ROLE";
export const RESET_ITEMS_ROLE = "RESET_ITEMS_ROLE";
export const RESET_SELECTED_ROLE = "RESET_SELECTED_ROLE";
export const GET_ROLE_EMPTY_DETAILS = "GET_ROLE_EMPTY_DETAILS";
export const SET_ROLE_EMPTY_DETAILS = "SET_ROLE_EMPTY_DETAILS";
export const RESET_ROLE_EMPTY_DETAILS = "RESET_ROLE_EMPTY_DETAILS";
export const ADD_ROLE_DETAIL = "ADD_ROLE_DETAIL";
export const EDIT_ROLE_DETAIL = "EDIT_ROLE_DETAIL";
export const SET_NEW_ROLE_DETAIL = "SET_NEW_ROLE_DETAIL";
export const DELETE_ROLE_DETAIL = "DELETE_ROLE_DETAIL";
export const SET_DELETE_ROLE_DETAIL = "SET_DELETE_ROLE_DETAIL";
export const RESET_LIST_ROLES = "RESET_LIST_ROLES";
